import { activeCampaignAddContact } from './api';

//

function get_prevsite() {
    const urlParams = new URLSearchParams(window.location.search);
    let source = urlParams.get('utm_source');
    let medium = urlParams.get('utm_medium');

    // Verifica sessionStorage para el referente original
    let ref = sessionStorage.getItem('original_ref');
    if (!ref) {
        // Si no se almacena ningún referente original, utiliza document.referrer o 'direct traffic' 
        ref = document.referrer || 'direct traffic';
        sessionStorage.setItem('original_ref', ref);
    }

    // Verifica sessionStorage para el sitio anterior
    let prevsite = sessionStorage.getItem('prevsite');

    // Almacena el document.referrer actual como el sitio anterior para la próxima visita
    sessionStorage.setItem('prevsite', document.referrer || 'direct traffic');

    return { ref, prevsite, source, medium };
}

//

window.addEventListener("load", () => {
    $("#form-yearbook").on("submit", submitForm);
})

const submitForm = async (event) => {
    event.preventDefault();

    const inputFullName = $("#fullname"),
        inputOrganization = $("#organization"),
        inputEmail = $("#email-careers"),
        inputJobTitle = $("#role"),
        chkPrivacy = $("#field_34"),
        form = $(event.target);
    let error = false;
    form.find(".error-field").remove();
    if (!window.grecaptcha.getResponse(window.end_form_captcha_id)) {
        $("#end_form_captcha").after(
            "<p id='error-captcha' class='error-field'>The captcha is missing or wrong</p>"
        );
        error = true;
    }
    if (!(controls_fields(inputFullName),
        controls_fields(inputOrganization),
        controls_fields(inputEmail),
        controls_fields(inputJobTitle),
        controls_fields(chkPrivacy))) {
        error = true;
    }
    if (error) return

    const successUrl = form.attr("data-link"),
        /*
        ref = get_ref(),
        prevSite = get_prevsite(),
        */
        contactUrl = window.location.href,
        device = get_device_type(),
        captchaResponse = grecaptcha.getResponse(window.end_form_captcha_id);

    const fullName = inputFullName.val();
    const company = inputOrganization.val();
    const jobTitle = inputJobTitle.val();
    const email = inputEmail.val();
    //
    const referrerData = get_prevsite();
    const ref = referrerData.ref;
    const prevSite = referrerData.prevsite;
    const source = referrerData.source || "";
    const medium = referrerData.medium || "";
    const gdpr2019 = $("#field_34").prop("checked");
    const suscription = $("#field_suscription_people").prop("checked");
    //
    /*
    const gdpr2019 = "I've read and agree to Abstracta's privacy policy."; 
    */
    try {
        $(".btn-contact").addClass("loading")
        await activeCampaignAddContact({
            fullName, company, email, formId: "139", jobTitle, ref, prevSite, source, medium, gdpr2019, suscription, contactUrl, device, captchaResponse
        })
        form.find('.btn-contact').removeClass("loading");
        form[0].reset();
        window.location.href = successUrl;
    }
    catch (e) {
        form.find('.btn-contact').removeClass("loading");
        form.find('.div-submit').append("<p class='error-field error-field-large'>There was an error, please try again.</p>")
    }

}